/**
 * ModalContent Class
 * 모달에 주입할 컨텐츠를 관리하는 클래스
 */
export class ModalContent {
    constructor(options = {}) {
        this.title = options.title || '';
        this.message = options.message || '';
        this.html = options.html || null;
        this.icon = options.icon || null;
        this.buttons = options.buttons || [];
    }

    /**
     * 제목 설정
     */
    setTitle(title) {
        this.title = title;
        return this;
    }

    /**
     * 메시지 설정
     */
    setMessage(message) {
        this.message = message;
        return this;
    }

    /**
     * HTML 컨텐츠 설정
     */
    setHTML(html) {
        this.html = html;
        return this;
    }

    /**
     * 아이콘 설정
     */
    setIcon(icon) {
        this.icon = icon;
        return this;
    }

    /**
     * 버튼 추가
     */
    addButton(button) {
        this.buttons.push(button);
        return this;
    }

    /**
     * 컨텐츠 렌더링
     */
    render() {
        if (this.html) {
            return this.html;
        }

        let content = '';

        if (this.icon) {
            content += `<div class="no-modal__icon">${this.icon}</div>`;
        }

        if (this.title) {
            content += `<h3 class="no-modal__title">${this.title}</h3>`;
        }

        if (this.message) {
            content += `<p class="no-modal__message">${this.message}</p>`;
        }

        if (this.buttons.length > 0) {
            content += '<div class="no-modal__buttons">';
            this.buttons.forEach(button => {
                const classes = button.class || 'no-btn no-btn--main';
                const text = button.text || '확인';
                const action = button.action || '';
                content += `<button type="button" class="${classes}" data-action="${action}">${text}</button>`;
            });
            content += '</div>';
        }

        return content;
    }
}

